module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAA80lEQVQ4jb2VvRHCMAyFXTAARQqKjEGRnhFYwIX0tEa2oGSAZIsMkcKDUFCEJiY+Rc4fd+hO3dNnyZJl5zJGRBWAHsCgvCeiKhc3MxG5GhDTReS6CGPmJgkI3vuz1gAoAISoY+ZmC6xYq2QE29C0TB1Y1/VJRB7M/PTeXwzwvPxcZmNj9N1RLlMdFHKnazd0AcBARJWLo5FpwFZgzLJ3OdEeYKr9O7AzgN1hIBGVGkhE5RowvldzmDeWOzVlaWx2AKexUUHfLEXkBuBtNYWZ70Z202Fqw7zWtoylnW0eAO0OkPbWuoqjUBuWKf+3BZva0S/gA4+Gyx4/ZdAkAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/images/pc_icon_01.png
// module id = o2sK
// module chunks = 2